<script setup>
import { LayoutContentContainer as ContentContainer } from '@web-nfb/vue-3-components'

import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const locale = computed(() => store.getters['Global/locale'])
</script>
<template>
  <footer class="nfb-footer">
    <ContentContainer>
      <div class="nfb-footer__details-container">
        <div class="nfb-footer__details-item">
          <a
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
            :href="$t('url.createAccount')"
          >
            {{ $t("footer.createAccount") }}
          </a>
          <a
            :href="$t('url.newsletter')"
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
          >
            {{ $t("footer.newsletter") }}
          </a>
          <a
            :href="$t('url.events')"
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
          >
            {{ $t("footer.events") }}
          </a>
          <a
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
            :href="$t('url.production')"
          >
            {{ $t("footer.createWith") }}
          </a>
          <a
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
            :href="$t('url.publicScreening')"
          >
            {{ $t("footer.publicScreening") }}
          </a>
        </div>
        <div class="nfb-footer__details-item">
          <a
            :href="$t('url.about')"
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
          >
            {{ $t("footer.about") }}
          </a>
          <a
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
            :href="$t('url.helpCenter')"
          >
            {{ $t("footer.helpCenter") }}
          </a>
          <a
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
            :href="$t('url.contactUs')"
          >
            {{ $t("footer.contactUs") }}
          </a>
          <a
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
            :href="$t('url.mediaSpace')"
          >
            {{ $t("footer.mediaSpace") }}
          </a>
          <a
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
            :href="$t('url.jobs')"
          >
            {{ $t("footer.jobs") }}
          </a>
        </div>
        <div class="nfb-footer__details-item">
          <a
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
            :href="$t('url.production')"
          >
            {{ $t("footer.production") }}
          </a>
          <a
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
            :href="$t('url.distribution')"
          >
            {{ $t("footer.distribution") }}
          </a>
          <a
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
            :href="$t('url.education')"
          >
            {{ $t("footer.education") }}
          </a>
          <a
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
            :href="$t('url.archives')"
          >
            {{ $t("footer.archives") }}
          </a>
          <a
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
            :href="$t('url.blog')"
          >
            {{ $t("footer.blog") }}
          </a>
        </div>
        <div class="nfb-footer__details-item nfb-footer__details-item--social">
          <a
            :href="$t('url.facebook')"
            class="nfb-footer__social"
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
          >
            <span class="nfb-footer__social-text">Facebook</span>
            <i class="nfb-icon icon-facebook nfb-footer__social-icon" />
          </a>
          <a
            :href="$t('url.youtube')"
            class="nfb-footer__social"
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
          >
            <span class="nfb-footer__social-text">Youtube</span>
            <i class="nfb-icon icon-youtube nfb-footer__social-icon" />
          </a>
          <a
            :href="$t('url.instragram')"
            class="nfb-footer__social"
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
          >
            <span class="nfb-footer__social-text">Instagram</span>
            <i class="nfb-icon icon-instagram nfb-footer__social-icon" />
          </a>
          <a
            :href="$t('url.vimeo')"
            class="nfb-footer__social"
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
          >
            <span class="nfb-footer__social-text">Vimeo</span>
            <i class="nfb-icon icon-vimeo nfb-footer__social-icon" />
          </a>
          <a
            :href="$t('url.twitter')"
            class="nfb-footer__social"
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
          >
            <span class="nfb-footer__social-text">X</span>
            <i class="nfb-icon icon-twitter-x nfb-footer__social-icon" />
          </a>
        </div>
      </div>
      <div class="nfb-footer__apps-container">
        <a
          :href="$t('url.apps')"
          data-gtm-event="nfb_menu"
          data-gtm-nfb_detail="footer"
        >
          {{ $t("footer.apps") }}
        </a>
        <div class="nfb-footer__apps-items">
          <a
            :href="$t('url.appleStore')"
            :class="`nfb-logo__apple-app-${locale}`"
            data-gtm-event="nfb_to_app_store"
            data-gtm-nfb_detail="footer"
          />
          <a
            :href="$t('url.googlePlayStore')"
            :class="`nfb-logo__google-play-${locale}`"
            data-gtm-event="nfb_to_app_store"
            data-gtm-nfb_detail="footer"
          />
          <a
            :href="$t('url.fireTV')"
            class="nfb-logo__fire-tv"
            data-gtm-event="nfb_to_app_store"
            data-gtm-nfb_detail="footer"
          />
          <a
            :href="$t('url.roku')"
            class="nfb-logo__roku"
            data-gtm-event="nfb_to_app_store"
            data-gtm-nfb_detail="footer"
          />
          <a
            :href="$t('url.appleTV')"
            :class="`nfb-logo__apple-tv-${locale}`"
            data-gtm-event="nfb_to_app_store"
            data-gtm-nfb_detail="footer"
          />
          <a
            :href="$t('url.androidTV')"
            class="nfb-logo__android-tv"
            data-gtm-event="nfb_to_app_store"
            data-gtm-nfb_detail="footer"
          />
        </div>
      </div>
      <div class="nfb-footer__others-container">
        <div class="nfb-footer__others-items">
          <a
            :href="$t('url.accessibility')"
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
          >
            {{ $t("footer.accessibility") }}
          </a>
          <a
            :href="$t('url.institutionalWebsite')"
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
          >
            {{ $t("footer.institutionalWebsite") }}
          </a>
          <a
            :href="$t('url.termsOfUse')"
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
          >
            {{ $t("footer.termsOfUse") }}
          </a>
          <a
            :href="$t('url.privacy')"
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
          >
            {{ $t("footer.privacy") }}
          </a>
        </div>
        <div class="nfb-footer__others-items">
          <span
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
          >
            © {{ $t("footer.nfb") }}
          </span>
          <a
            :href="$t('url.canadaGov')"
            data-gtm-event="nfb_menu"
            data-gtm-nfb_detail="footer"
            class="nfb-logo__canada"
          />
        </div>
      </div>
    </ContentContainer>
  </footer>
</template>
<style lang="sass">
@use '@node_modules/@web-nfb/frontend-static/design-system/sass/elements/footer'
@use '@node_modules/@web-nfb/frontend-static/design-system/sass/fonts/logos'

.l-bigContainer
  width: 100%
</style>
